<template>
  <ion-page>
    <ion-header class="ion-no-border">
      <ion-toolbar color="light">
        <ion-buttons slot="start">
          <ion-button color="primary" @click="cancel()">
            <ion-icon slot="icon-only" :icon="close"></ion-icon>
          </ion-button>
        </ion-buttons>

        <ion-title>Nieuw bouwdeel
          <span color="medium" class="x-small new-line"> Bovenliggend: {{ parentName }} </span>
        </ion-title>

        <ion-buttons slot="end">
          <ion-button color="primary" @click="confirm()">
            <mdicon name="content-save"></mdicon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content color="light">
      <ion-list :inset="true" class="background-custom-white">
        <ion-item>
          <ion-input ref="name" class="lg" placeholder="Omschrijving van ruimte" autocapitalize="sentences"
            v-model="location_item.name"></ion-input>
        </ion-item>

        <div class="ma-1 mx-3 background-custom-white" v-if="last_searched_items.length > 0">
          <ion-chip class="sm" v-ripple v-for="item in last_searched_items" :key="item.uuid"
            @click.stop="selectLocationItem(item)">
            <ion-label class="small">{{ item.name }}</ion-label>
          </ion-chip>
        </div>

        <ion-item>
          <ion-label>Hoeveel aanmaken?</ion-label>
          <ion-select mode="ios" okText="Kies" cancelText="Annuleren" type="number" v-model="amount">
            <ion-select-option v-for="number in 50" :value="number" :key="number">
              {{ number }}</ion-select-option>
          </ion-select>
        </ion-item>
        <ion-item v-if="amount > 1">
          <ion-label>Nummers toevoegen</ion-label>
          <ion-toggle v-model="numbering"></ion-toggle>
        </ion-item>
        <ion-item class="input-right-align" v-if="amount > 1 && numbering">
          <ion-label>Startnummer</ion-label>
          <ion-input type="number" v-model="start_number"></ion-input>
        </ion-item>
      </ion-list>
      <ion-list :inset="true" class="background-custom-white">
        <div class="ml-5 mt-5 mb-2 background-custom-white">
          <ion-label class="ion-text-wrap">
            <strong>Ruimtefuncties</strong>
          </ion-label>
        </div>
        <div class="mx-5">
          <div class="pb-5">
            <div v-ripple v-for="(location_item_type, index) in location_item_types" :key="index" class="list-item"
              @click="toggleSelection(location_item_type.id)"
              :class="{ 'selected-row': isSelected(location_item_type.id) }">
              <ion-label class="ion-text-wrap smaller">{{ location_item_type.name }} <small>({{
                location_item_type.code
              }})</small></ion-label>
              <mdicon v-if="isSelected(location_item_type.id)" class="ml-2 text-primary" name="check-circle-outline">
              </mdicon>
            </div>

            <no-data v-if="location_item_types.length == 0">
              <template #info>
                <p class="no-data-title">
                  Geen ruimtefuncties gevonden
                </p>
              </template>
            </no-data>
          </div>
        </div>
      </ion-list>
    </ion-content>
  </ion-page>
</template>

<script lang="js">
import {
  IonContent, IonInput, IonIcon, IonHeader, modalController
} from '@ionic/vue';
import { save, add, list, albumsOutline, close, chevronBack } from 'ionicons/icons';
import uuid from '../../plugins/uuid';
import { db } from '../../services/db';
import convert from '@/services/convert'
import NoData from '@/components/NoData'


export default {
  name: 'location-item-create',
  components: {
    IonContent,
    IonInput,
    IonIcon,
    IonHeader,
    NoData
  },
  props: [
    'parent_uuid',
    'inspection_id',
    'location_id',
    'order_id'
  ],
  setup() {
    return {
      add,
      list,
      albumsOutline,
      save,
      close,
      chevronBack,
    }
  },
  data() {
    return {
      loading: false,
      location_item_types: [],
      location_item: {
        name: "",
        uuid: uuid(),
        parent_uuid: null,
        inspection_id: null,
        installation_type_id: null,
        space_type_id: null,
        location_item_type_ids: [],
      },
      parent_name: null,
      parent: null,
      amount: 1,
      numbering: false,
      start_number: 1,
      location_item_type_ids: [],
      last_searched_items: [],
    }
  },
  created() {
    this.getParent()
    this.setup()
    this.setLastSearchedItems()
  },
  methods: {
    async setLastSearchedItems() {
      await db.location_items.toArray().then((items) => {
        // we filter the items on created_by = this.$store.getters.getUser.id and sort bij created_at (recent first) max 5 items
        this.last_searched_items = items.filter((item) => item.created_by == this.$store.getters.getUser.id)
        // we should parse created_at to a date object
        this.last_searched_items = items.sort((a, b) => new Date(b.created_at) - new Date(a.created_at)).slice(0, 5)
      })
    },
    selectLocationItem(item) {
      this.location_item.name = item.name

      this.location_item_type_ids = item.location_item_type_ids

      this.$toast.success('Gegevens van ruimte zijn ingevuld')
    },
    toggleSelection(id) {
      const index = this.location_item_type_ids.indexOf(id);
      if (index >= 0) {
        this.location_item_type_ids.splice(index, 1);
      } else {
        this.location_item_type_ids.push(id);
      }
    },
    isSelected(id) {
      return this.location_item_type_ids.indexOf(id) >= 0;
    },
    async setup() {
      this.loading = true;
      try {
        this.location_item_types = await this.$requests.get('location_item_types', '/location-item-types').then(lics => {
          return lics.sort((a, b) => a.name.localeCompare(b.name));
        });

        this.location_item_types.forEach((item) => {
          if (item.default) {
            this.location_item_type_ids.push(item.id);
          }
        });

        // Add default items to selection
        this.location_item_types.forEach((item) => {
          if (item.default) {
            this.location_item_type_ids.push(item.id);
          }
        });
      } catch (error) {
        console.error('Error fetching location item types:', error);
        // handle the error accordingly
      }

      this.loading = false;
      this.$refs.name.$el.setFocus();
    },
    cancel() {
      return modalController.dismiss(null, 'cancel');
    },
    async confirm() {
      // validate name and max name length 150

      if (this.location_item.name.length < 1) {
        this.$toast.error('Omschrijving van ruimte')
        return
      }

      if (this.location_item.name.length > 150) {
        this.$toast.error('Omschrijving van ruimte mag maximaal 150 tekens bevatten')
        return
      }

      var start_number = this.start_number - 1;
      var order_id = this.order_id;
      let location_items = []

      for (let i = 0; i < this.amount; i++) {
        start_number++
        order_id++

        let name = this.numbering ? convert.smartNumber(this.location_item.name, start_number) : this.location_item.name

        let location_item =
        {
          created_by: this.$store.getters.getUser.id,
          parent_uuid: this.parent_uuid,
          inspection_id: parseInt(this.$store.getters.getInspectionId),
          location_id: this.location_id,
          order_id: order_id,
          location_item_type_ids: this.location_item_type_ids,
          location_item_types: this.location_item_types.filter((location_item_type) => {
            return this.location_item_type_ids.includes(location_item_type.id)
          }),
          uuid: uuid(),
          name: name.charAt(0).toUpperCase() + name.slice(1),
          in_inspection: true,
        }

        let state = {
          opened: true,
          uuid: location_item.uuid
        }
        this.$store.dispatch('setLocationItemState', state)

        let parent = await this.getParent()

        if (parent) {
          parent.state.opened = true

          let parent_state = {
            opened: true,
            uuid: parent.uuid
          }

          this.$store.dispatch('setLocationItemState', parent_state)
        }

        location_items.push(location_item)
      }

      let url = '/inspections/' + parseInt(this.$store.getters.getInspectionId) + '/bulk-location-items'
      this.$requests.post('location_items', url, { location_items: location_items })

      this.$store.dispatch('setComponentCountKey')

      modalController.dismiss(null, 'confirm');
    },
    async getParent() {
      if (this.parent_uuid) {
        let parent = await db.location_items.where({ uuid: this.parent_uuid }).first()
        if (parent) {
          this.parent = parent
        }

        this.parent_name = parent.name
      }
    }
  },
  computed: {
    parentName() {
      return this.parent_name
    }
  }

};
</script>
